import { PermissionEnum } from "app/constants/permissionConst";
import { RouterParameters } from "app/constants/routerConst";
import ReaderFirmwareScreen from "app/screens/ReaderFirmwareScreen/ReaderFirmwareScreen";
import { IMenuItemType } from "app/types/routerType";

/**
 * Reader Firmware Screen
 */
export const READER_FIRMWARE_SCREEN: IMenuItemType = {
  id: "readerfirmware",
  path: "/reader-firmware/" + RouterParameters.TAB,
  component: ReaderFirmwareScreen,
  browserTitle: "readerFirmware.browserTitle",
  navigationTitle: "readerFirmware.navigationTitle",
  pageTitle: "readerFirmware.pageTitle",
  icon: "desktop",
  permissions: [PermissionEnum.DESKTOP_VERSION_READ],
};

/**
 * Create screen for different readers firmware
 */
export const READER_FIRMWARE_CREATE_SCREEN: IMenuItemType = {
  ...READER_FIRMWARE_SCREEN,
  path: READER_FIRMWARE_SCREEN.path + RouterParameters.CREATE,
  permissions: [PermissionEnum.DESKTOP_VERSION_WRITE],
};
